import React, { useCallback, useEffect, useState } from "react";
import { Autocomplete } from "@material-ui/lab";
import { Box, CircularProgress, TextField } from "@material-ui/core";
import PhoneNumberInput from "material-ui-phone-number";

const noResultsText = 'No Results Found';
const minCharForPhoneSearch = 3;
const minCharForSearch = 1;

const SearchComponent = props => {
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchResults, setSearchResults] = useState([]);

  const {
    getOptionLabel,
    handleSearch,
    label,
    name,
    onBlur,
    onChange,
    onFocus,
    renderOption,
    usePhoneNumberInput
  } = props;
  const { errors, setFieldValue, values } = props.formikProps;

  const search = useCallback(
    value => {
      handleSearch(value)
        .then(({ data }) => {
          setSearchResults(data);
          setSearchLoading(false);
        })
        .catch(() => setSearchLoading(false));
    },
    [handleSearch]
  );

  useEffect(() => {
    if (searchLoading) {
      const timeOut = setTimeout(() => search(values[name]), 600);
      return () => clearTimeout(timeOut);
    }
  }, [name, search, searchLoading, values]);

  const setSearchResultDisplay = bool => {
      setSearchLoading(bool);
      setSearchOpen(bool);
  };

  return (
    <React.Fragment>
      <Autocomplete
        loading={searchLoading}
        noOptionsText={noResultsText}
        onBlur={() => {
          setSearchResultDisplay(false);
          onBlur && onBlur();
        }}
        onChange={(e, v) => {
          onChange(e, v);
          setSearchResultDisplay(false);
        }}
        onFocus={e => {
          onFocus && onFocus(e);
          setSearchResults([]);
        }}
        open={searchOpen}
        options={searchResults}
        id={name}
        getOptionLabel={getOptionLabel && getOptionLabel}
        renderOption={renderOption && renderOption}
        renderInput={params =>
          usePhoneNumberInput ? (
            <PhoneNumberInput
              {...params}
              autoFormat={false}
              defaultCountry="us"
              disableAreaCodes
              error={errors && Boolean(errors[name])}
              fullWidth
              helperText={errors && errors[name] && errors[name]}
              label={label}
              InputProps={{
                endAdornment: (
                  <Box mr={8}>
                    {searchLoading && (
                      <CircularProgress color="primary" size={15} />
                    )}
                    {params.InputProps.endAdornment}
                  </Box>
                ),
                ref: params.InputProps.ref
              }}
              onChange={e => {
                setFieldValue(name, e);
                if (e.length > minCharForPhoneSearch) {
                  setSearchResultDisplay(true);
                } else {
                  setSearchResultDisplay(false);
                }
              }}
            />
          ) : (
            <TextField
              {...params}
              error={errors && Boolean(errors[name])}
              helperText={errors && errors[name] && errors[name]}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {searchLoading && (
                      <CircularProgress color="primary" size={15} />
                    )}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                )
              }}
              onChange={e => {
                setFieldValue(name, e.target.value);
                if (e.target.value.length > minCharForSearch) {
                  setSearchResultDisplay(true);
                } else {
                  setSearchResultDisplay(false);
                }
              }}
              label={label}
              fullWidth
            />
          )
        }
        value={values[name]}
      />
    </React.Fragment>
  );
};

export default SearchComponent;
